import { Outlet, createRootRoute } from "@tanstack/react-router"
import React, { Suspense } from "react"

import DemoBanner from "@/components/Common/DemoBanner"
import ErrorView from "@/components/Common/ErrorView"
import NotFound from "@/components/Common/NotFound"
import { Toaster } from "@/components/ui/toaster"
import { OrganizationProvider } from "@/contexts/OrganizationContext"
import { SidebarProvider } from "@/contexts/SidebarContext"

const loadDevtools = () =>
  Promise.all([
    import("@tanstack/router-devtools"),
    import("@tanstack/react-query-devtools"),
  ]).then(([routerDevtools, reactQueryDevtools]) => {
    return {
      default: () => (
        <>
          <routerDevtools.TanStackRouterDevtools />
          <reactQueryDevtools.ReactQueryDevtools />
        </>
      ),
    }
  })

const TanStackDevtools =
  process.env.NODE_ENV === "production" ? () => null : React.lazy(loadDevtools)

export const Route = createRootRoute({
  component: () => (
    <OrganizationProvider>
      <SidebarProvider>
        {/* Banner mounts here (not in _layout) so that it surfaces on
            /login and every other public route too — operators flipping
            demo mode ON should see the indicator everywhere, not only on
            authenticated pages. */}
        <DemoBanner />
        <Outlet />
        <Toaster />
        <Suspense>
          <TanStackDevtools />
        </Suspense>
      </SidebarProvider>
    </OrganizationProvider>
  ),
  notFoundComponent: () => <NotFound />,
  errorComponent: () => <ErrorView />,
})
